import { FeedbackForm } from '@/components/support/FeedbackForm'

export function SupportPage() {
  return (
    <main
      id="main"
      className="max-w-site px-margin-mobile md:px-margin-desktop mx-auto w-full flex-grow pt-24 pb-24"
    >
      <div className="mx-auto max-w-2xl space-y-8">
        <h1 className="text-headline-lg-mobile text-fg md:text-headline-lg">
          Support
        </h1>
        <p className="font-body text-body-md text-fg-muted">
          Bug, idea, or anything else. We read every note.
        </p>
        <FeedbackForm />
      </div>
    </main>
  )
}
